module.exports = __webpack_public_path__ + "static/media/AppExchange.059d6728.png";